<template>
    <el-card style="width: 100%;">
        <h2 class="xpqd">商品管理</h2>
        <page-wrap class="shop_gl">

            <!-- 搜索栏 -->
            <search-wrap>
                <el-form :model="search" label-width="70px" size="mini" onsubmit="return false" :inline="true">
                    <el-row>
                        <el-col :span="24">
                            <div class="bg">
                                <el-form-item label="商品名称:">
                                    <el-input v-model="search.g_name" placeholder="请输入"
                                              @keyup.enter.native="onSubmit()"></el-input>
                                </el-form-item>
                                <el-form-item label="审核状态:">
                                    <el-select v-model="search.review_status" clearable placeholder="请选择审核状态">
                                        <el-option v-for="item in review_status_sel" v-html="item.label"
                                                   :key="item.value"
                                                   :value="item.value" :label="item.label">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="销售状态:">
                                    <el-select v-model="search.sales_status" clearable placeholder="请选择销售状态">
                                        <el-option v-for="item in sales_status_sel" v-html="item.label"
                                                   :key="item.value"
                                                   :value="item.value" :label="item.label">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="商品分类:">
                                    <el-input placeholder="请选择商品分类" v-model="c_name" readonly class="pl50">
                                        <el-button type="info" slot="append" icon="el-icon-search"
                                                   @click="handle_ca = true">
                                        </el-button>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="收录状态:">
                                <el-select v-model="search.issubmitbaidu" filterable clearable collapse-tags
                                           placeholder="百度收录状态">
                                  <el-option
                                    v-for="item in shouludata"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="bg">
                        <el-form-item label="商品编号:">
                          <el-input v-model="search.g_id" placeholder="请输入"
                                    @keyup.enter.native="onSubmit()"></el-input>
                        </el-form-item>
                        <el-form-item label="名片位置:">
                          <el-select v-model="search.mp_rank" filterable clearable collapse-tags
                                     placeholder="请选择">
                            <el-option
                              v-for="item in mp_ranks"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>

                    <el-col :span="24" style="line-height: 40px;margin-left: 20px;">
                      <el-button type="primary" size="mini" @click="onSubmit()" icon="el-icon-search"
                                 title="查询商品">
                        查询
                      </el-button>
                      <el-button type="success" size="mini" @click="$router.push('/index/goods/add')" icon="el-icon-plus"
                                 title="添加商品">添加商品
                      </el-button>

                      <el-button type="warning" size="mini" @click="onExport()" icon='el-icon-download'
                                 title="用于查询分类编号">导出行业分类
                      </el-button>
                      <el-button type="info" size="mini" @click="showExport=true" icon="el-icon-upload"
                                 title="导入">导入
                      </el-button>
                      <el-button type="danger" size="mini" @click="onClear()" icon='el-icon-refresh'
                                 title="重置搜索条件">
                        重置
                      </el-button>
                      <el-button type="danger" size="mini" @click="upGoods(2)" icon="el-icon-bottom"
                                 title="下架">下架
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
            </search-wrap>
            <!-- 表格 -->
            <table-wrap>
                <el-table ref="table" :data="tableData" :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="编号" prop="g_id"></el-table-column>
                    <el-table-column label="封面" min-width='60'>
                        <template slot-scope="scope">
                            <img :src="scope.row.g_image" alt="" class="cover_img">
                        </template>
                    </el-table-column>
                    <el-table-column label="商品名称" prop="g_name" min-width='100' show-overflow-tooltip>
                        <template slot-scope="scope">
                            <a target="_blank" style="color: black;" :href="'https://www.ishouping.com/shangpin/'+scope.row.g_id">{{scope.row.g_name}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品分类" prop="c_name" min-width='50'>
                    </el-table-column>
                    <el-table-column label="金额" prop="price" min-width='50'>
                        <template slot-scope="scope">
                            <span v-if="scope.row.price>0">￥{{scope.row.price}}</span>
                            <span v-else>暂无定价</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品状态" prop="search.review_status" min-width='70'>
                        <template slot-scope="scope">
                            <span v-if="scope.row.review_status==1">审核中</span>
                            <span v-if="scope.row.review_status==2">已审核</span>
                            <el-tooltip class="item" effect="dark" :content="scope.row.memo" placement="top">
                                <el-button  type="text" v-if="scope.row.review_status==3" >已拒审</el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售状态" prop="search.sales_status" min-width='50'>
                        <template slot-scope="scope">
                            <span v-if="scope.row.sales_status==1">未销售</span>
                            <span v-if="scope.row.sales_status==2">销售中</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="百度收录" min-width='90px'>
                      <template slot-scope="scope">
                        <span v-if="scope.row.issubmitbaidu == 1">{{scope.row.issubmitbaidu_name}}</span>
                        <el-button type="text" @click="openCase(scope.row)"  v-else>{{scope.row.issubmitbaidu_name}}</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="视频状态" min-width='90px'>
                      <template slot-scope="scope">
                        <el-button v-if="scope.row.g_video_uri != ''" type="text" @click="openVideo(scope.row)">{{scope.row.g_video_status == 1?'通过':(scope.row.g_video_status == 2?'未通过':'待审核')}}</el-button>
                      </template>
                    </el-table-column>
                  <el-table-column prop="mp_rank" label="名片位置" min-width='80px'>
                    <template slot-scope="scope">
                      <span v-show="scope.row.mp_rank != 0">{{scope.row.mp_rank}}</span>
                    </template>
                  </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                          <el-button @click="onEdit(scope.row.g_id, 1)" type="text" size="medium" icon='el-icon-edit-outline' title="编辑"></el-button>
                          <el-button @click="onEdit(scope.row.g_id, 2)" type="text" size="small" icon="el-icon-document-copy" title="复制"></el-button>
                          <el-button v-if="scope.row.sales_status == 1" @click="onChangeStatus(scope.row.g_id, 2)" type="text" size="small" icon="el-icon-top" title="上架"></el-button>
                          <el-button v-if="scope.row.sales_status == 2" @click="onChangeStatus(scope.row.g_id, 1)" type="text" size="small" icon="el-icon-bottom" title="下架"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </table-wrap>
            <el-dialog title="导入" :visible="showExport" :modal=true :close-on-click-modal="false"
                       :close-on-press-escape="false" width="30%" @close="showExport=false" class="close">
                <el-upload action="/index.php/goods/Goods/import" :before-upload="beforeUpload" :show-file-list="false"
                           :on-success="onSuccess"
                           style="float: right">
                    <el-button type="success" size="small" icon='el-icon-plus'>选择导入文件</el-button>
                </el-upload>
                <el-button size="small" icon="el-icon-download" type="primary" @click="downDemo">下载模板</el-button>
                <!--<span class="Explain">-->
                <!--<h3>导入说明</h3>-->
                <!--1. 请保持第一行字段名称同模板一致，包括文字以及符号。<br>-->
                <!--2. 带“*”号的为必填字段。<br>-->
                <!--3. 题目类型为“单选题”“多选题”“判断题”。<br>-->
                <!--4. 单选题的正确答案只允许填写“ABCD”四种且至少包含A、B两个选项，最多不超过4个选项。<br>-->
                <!--5. 多选题的正确答案只允许填写“ABCDE”五种且至少包含A、B两个选项，最多不超过5个选项。<br>-->
                <!--6. 单选题与多选题的正确答案需要在指定选项个数范围内，否则不允导入。<br>-->
                <!--7. 判断题的正确答案只允许填写“正确”或“错误”。<br>-->
                <!--</span>-->
            </el-dialog>
            <!-- dialog未收录原因 -->
            <el-dialog
              title="说明"
              :visible.sync="handleCase"
              width="30%"
              @close="handleCase = false;caseMsg = ''">
              <span>{{caseMsg}}</span>
              <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="handleCase = false;caseMsg = ''">确 定</el-button>
              </span>
            </el-dialog>

            <!-- 分页 -->
            <pagination :data="pagination" @submit="onSubmit"/>
            <!--其它-->
            <!--<add v-if="handleAddIf" @callback="callbackAdd"/>-->
            <!--<edit v-if="handleEditIf" :data="rowIndex" @callback="callbackEdit"/>-->
            <Category :handle="handle_ca" @closeSelf="closeCategory" @confirm="callbackCat" :c_id="search.c_id"/>
        </page-wrap>
    </el-card>
</template>


<script>
    import Add from "./Add.vue";
    import Edit from "./Edit.vue";
    import Category from '../../components/dialog/Category'

    export default {
        components: {
            Add,
            Edit,
            Category
        },
        data() {
            return {
                search: {g_name: "", review_status: "", sales_status: "", c_id: 0,g_id:'',mp_rank:''}, // 搜索词
                mp_ranks:[{value:0,label:'未设置'},{value:1,label:1},{value:2,label:2},{value:3,label:3},{value:4,label:4},
                {value:5,label:5},{value:6,label:6},{value:7,label:7},{value:8,label:8},{value:9,label:9},{value:10,label:10}],
                c_name: '',
                pagination: {currentPage: 1, pageSize: 50, total: 0}, // 分页相关数据
                loading: false,
                tableData: [],
                tableHeight: null,
                handleAddIf: false,
                handleEditIf: false,
                showExport: false,
                handle_ca: false,
                rowIndex: {},
                review_status_sel: [{label: '审核中', value: 1}, {label: '已审核', value: 2}, {label: '已拒审', value: 3}],
                sales_status_sel: [{label: '未销售', value: 1}, {label: '销售中', value: 2}],
                shouludata:[{value:0,label:'未收录'},{value:1,label:'已收录'}],
                handleCase: false,
                caseMsg:'',
                ids:[],
            };
        },
        computed: {},
        mounted() {
            let p = document.getElementsByClassName('paginationWrap')[0].offsetTop;
            let t = document.getElementsByClassName('tableWrap')[0].offsetTop;
            let h = document.getElementsByClassName('el-table__header-wrapper')[0].offsetHeight;
            this.tableHeight = p - h - t;
            let query = this.$route.query;
            this.search.review_status = Number(query.review_status) > -1 ? Number(query.review_status) : '';
            this.search.sales_status = Number(query.sales_status) > -1 ? Number(query.sales_status) : '';
            this.handleAddIf = Number(query.is_add) === 1;
            this.onSubmit();
        },
        watch: {},
        methods: {
          handleSelectionChange(selection) {
            this.ids = selection.map(item => item.g_id)
          },
          upGoods(status){
            let that = this;
            let msg = '';
            if(status == 1){
              msg="上架";
              status = 2;
            }else{
              msg="下架";
              status = 1;
            }
            this.$confirm(
              "确定批量"+msg+"商品吗?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            )
              .then(() => {
                this.$ajax
                  .post("goods/Goods/editSales", {g_id: that.ids, status:status})
                  .then(function (res) {
                    if (res.data.error === 0) {
                      that.$message({
                        type: "success",
                        message: msg+"成功!"
                      });
                      that.onSubmit(that.pagination);
                    } else {
                      that.$message(res.data.message);
                    }
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消"+msg
                });
              });
          },
            downDemo() {
                window.location = `/index.php/goods/Goods/exportDemo`;
            },
            beforeUpload(file, fileList) {
                let ext = file.name.split(".").pop();
                if (ext !== "xlsx") {
                    this.$message("请选择xlsx模板文件上传！");
                    return false;
                }
            },
            onSuccess(response, file, fileList) {
                if (response.type==='success'){
                    this.showExport = false;
                    this.onSubmit(this.pagination);
                }
                this.$message({
                    message: response.info,
                    type: response.type
                });
            },
            onSubmit(pagination = null) {
                let that = this;
                if (pagination !== null) {
                    that.pagination = pagination;
                } else {
                    that.pagination.currentPage = 1;
                }
                if (this.loading) {
                    return;
                }
                this.$ajax
                    .post("/goods/Goods/index", {
                        search: that.search,
                        paginate: that.pagination
                    })
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.tableData = res.data.data.data;
                            that.pagination.total = res.data.data.total;
                            that.loading = false;
                        }
                    })
                    .catch(function (err) {
                        that.$message("网络错误！请联系管理员");
                        that.loading = false;
                    });
            },
            onClear() {
                for (let key in this.search) {
                    this.search[key] = "";
                }
            },
            callbackAdd(data) {
                this.handleAddIf = false;
                if (data) {
                    this.$message({
                        type: "success",
                        message: "添加成功!"
                    });
                    this.onSubmit(this.pagination);
                }
            },
            callbackEdit(data) {
                this.handleEditIf = false;
                if (data) {
                    this.$message({
                        type: "success",
                        message: "编辑成功!"
                    });
                    this.onSubmit(this.pagination);
                }
            },
            onChangeStatus(g_id, status) {
                let that = this;
                let action = status === 1 ? "下架" : "上架";
                this.$confirm("确定" + action + "此商品吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$ajax
                            .post("goods/Goods/changeShelf", {g_id: g_id, sales_status: status})
                            .then(function (res) {
                                if (res.data.error === 0) {
                                    that.$message({
                                        type: "success",
                                        message: action + "成功!"
                                    });
                                    that.onSubmit(that.pagination);
                                } else {
                                    that.$message(res.data.message);
                                }
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消"
                        });
                    });
            },
            onEdit(row,type) {
                var data = {};
                data.id = row;
                data.type = type;
                this.rowIndex = data;
                this.handleEditIf = true;
                this.$router.push("/index/goods/edit/"+row+"/"+type)
            },
            callbackCat(data) {
                this.handle_ca = false;
                this.search.c_id = data.last_value;
                this.c_name = data.last_label;
            },
            closeCategory() {
                this.handle_ca = false;
            },
            onExport() {
                window.location = '/index.php/goods/Goods/exportCate'
            },

            openCase(row){
                let that = this;
                this.$ajax.get(this.$work_host+'/index.php/admin/login/indexSituation?g_id='+row.g_id).then(function (res) {
                    that.handleCase = true;
                    that.caseMsg = res.data.data;
                }).catch(function () {
                    that.$message.error('网络错误,请刷新')
                })
            },
            openVideo(row){
                let that = this;
                this.$ajax.get(this.$work_host+'/index.php/admin/login/indexVideo?g_id='+row.g_id).then(function (res) {
                    that.handleCase = true;
                    that.caseMsg = res.data.data;
                }).catch(function () {
                    that.$message.error('网络错误,请刷新')
                })
            },
        }
    };
</script>

<style>
    .cover_img {
        width: auto;
        height: auto;
        max-width: 50%;
        max-height: 50%;
        padding: 5px;
    }

</style>



// WEBPACK FOOTER //
// src/views/goods/Index.vue